/**
 * Popup catalog — add or edit entries here to change what visitors see.
 *
 * Each popup has:
 *  - id: unique key (used for frequency cap)
 *  - brand: "truwe" | "vibe" — controls visual variant
 *  - routes: array of path prefixes where the popup is eligible (["*"] = anywhere)
 *  - trigger: how it opens (exit-intent / scroll / time / action / route)
 *  - copy: headline, sub, offer line, CTA label
 *
 * To add a new popup: append a new entry to POPUPS, then it's automatically
 * picked up by the trigger engine. To swap brand styling, change `brand`.
 */

export type PopupBrand = "truwe";

export type PopupTrigger =
  | { kind: "exit-intent" }
  | { kind: "scroll"; percent: number }
  | { kind: "time"; seconds: number }
  | { kind: "action"; action: string } // fired manually via window dispatchEvent("identity:action", { detail: { action } })
  | { kind: "route" }; // fires immediately when route matches

export type PopupConfig = {
  id: string;
  brand: PopupBrand;
  routes: string[]; // ["/"], ["/products/"], ["*"]
  trigger: PopupTrigger;
  headline: string;
  sub: string;
  offer: string;
  cta: string;
  // Optional: skip if visitor is already identified
  skipIfIdentified?: boolean;
  // Devices: "all" | "desktop" | "mobile"
  devices?: "all" | "desktop" | "mobile";
};

// Disabled — replaced by Founding 99 promo popup.
export const POPUPS: PopupConfig[] = [];

export function matchRoute(routes: string[], pathname: string): boolean {
  return routes.some((r) => {
    if (r === "*") return true;
    if (r === "/") return pathname === "/";
    return pathname === r || pathname.startsWith(r);
  });
}
